import { render, staticRenderFns } from "./AboutScreen.vue?vue&type=template&id=da71c4c4"
import script from "./AboutScreen.vue?vue&type=script&lang=ts"
export * from "./AboutScreen.vue?vue&type=script&lang=ts"
import style0 from "./AboutScreen.vue?vue&type=style&index=0&id=da71c4c4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports